import { a as attr } from "../../../../chunks/attributes.js";
import { z as bind_props } from "../../../../chunks/index2.js";
function Editor($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let { value = void 0 } = $$props;
    $$renderer2.push(`<div class="form-control"><div id="editorjs"></div></div>`);
    bind_props($$props, { value });
  });
}
function _page($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    const { data } = $$props;
    const alert = data.alert;
    let visible = alert.visible;
    let content = alert.content || { time: Date.now(), blocks: [] };
    let $$settled = true;
    let $$inner_renderer;
    function $$render_inner($$renderer3) {
      $$renderer3.push(`<h1 class="heading">Komunikat</h1> <form class="form-group"><div><label>Komunikat widoczny <input type="checkbox"${attr("checked", visible, true)}/></label></div> <div>`);
      Editor($$renderer3, {
        get value() {
          return content;
        },
        set value($$value) {
          content = $$value;
          $$settled = false;
        }
      });
      $$renderer3.push(`<!----></div> <div><button type="submit" class="btn">Zapisz</button></div></form>`);
    }
    do {
      $$settled = true;
      $$inner_renderer = $$renderer2.copy();
      $$render_inner($$inner_renderer);
    } while (!$$settled);
    $$renderer2.subsume($$inner_renderer);
  });
}
export {
  _page as default
};
